<div [formGroup]="currencyInfoForm">
    <div>
        <!--Currency Field-->
        <div class="row mt-3 form-group">
            <div class=" {{fromQuickCall ? 'col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12' :'col-md-4 col-lg-4 col-xl-4'}}">
                <label class="label" for="data" id="sd_currency_field">
                    {{ customField.displayName }}:
                    <span id="mandatory_field" *ngIf="required && customerEditable">&#42;</span>
                </label>
            </div>
            <div  class="{{fromQuickCall ? 'pl-3 col-xl-3 col-lg-3 col-md-7 col-sm-12 col-12'  :'col-md-7 col-lg-6 col-xl-6 col-10'}} sd_custom_input" >
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">{{currencyFormat}}</span>
                    </div>
                    <input class="form-control" type="text" id="sd_currency_field_value" (change)="currencyValueFormatter()" formControlName="data"
                        keyup="currencyValueUpdate()" [(ngModel)]="currencyFormattedValue" (focus)="currencyFieldFocus = true"
                        (blur)="currencyFieldFocus = false" name="currencyValue" [ngClass]="{'error-class':required && currencyInfoForm.controls['data'].touched 
                        && currencyValueEmpty() && !currencyFieldFocus}" maxlength="255" autocomplete="off">
                </div>
                <div *ngIf="required && currencyInfoForm.controls['data'].touched 
                    && currencyValueEmpty() && !currencyFieldFocus" class="validation-error-inline text-danger">
                    {{ customField.displayName }} {{ 'CustomField.fieldRequired' | translate }}
                </div>
            </div>


            <span *ngIf="customField.dscEnable === 1" [attr.data-toggle]="customField.fieldId" data-trigger="hover" [attr.data-content]="customField.description"
                class="align_description_icon">
                <em class="fa fa-question-circle fa-lg"></em>
            </span>

        </div>
    </div>
</div>